import firebase from "firebase/app";
import "firebase/firestore";
import "firebase/auth";
import "firebase/functions";
import "firebase/storage";

const firebaseConfig = {
	apiKey: "AIzaSyA9gMfvyJUuUYgiQezYrVhiTkt_fcxZsu8",
	authDomain: "alduin-app.firebaseapp.com",
	databaseURL: "https://alduin-app.firebaseio.com",
	projectId: "alduin-app",
	storageBucket: "alduin-app.appspot.com",
	messagingSenderId: "16091101621",
	appId: "1:16091101621:web:bde6d473f49ff0d2a601fc",
};

if (!firebase.apps.length) firebase.initializeApp(firebaseConfig);

const docHandler = (doc) => {
	let res = doc.data();
	res.id = doc.id;
	return res;
};
const docsHandler = (docs) => docs.docs.map(docHandler);

const auth = firebase.auth();
const db = firebase.firestore();
const functions = firebase.functions();
const storage = firebase.storage();
const user_col = db.collection("users");
const song_col = db.collection("songs");
const mailCol = db.collection("mail");
const get_users = () => user_col.get().then(docsHandler);
const inc = (x) => firebase.firestore.FieldValue.increment(x);
const translate = functions.httpsCallable("gtranslate");
export { auth, db, user_col, song_col, get_users, inc, translate };
export const dictionary_col = db.collection("dictionary");
export const getDownloadUrl = (ref) => storage.ref(ref).getDownloadURL();
export const searchGenius = functions.httpsCallable("genius_search");
export const getGSong = functions.httpsCallable("get_genius_song");
export const updateSong = functions.httpsCallable("updateSong");

// Firestore functions

export const genresCol = db.collection("music_genre");
export const getMusicTypes = async () => genresCol.get().then(docsHandler);
export const addEmailAdress = (email) =>
	mailCol.add({
		to: ["victorforissier@gmail.com"],
		message: {
			subject: "New beta request (Alduin)",
			text: `${email} veut rejoindre la beta.`,
		},
	});
